import * as actionTypes from './actionTypes';
import axiosRoot from 'axios';
import axios from '../../axios-api';

export const changeBackground = (index) => {
    return {
        type: actionTypes.CHANGE_BACKGROUND,
        index: index
    };
};

export const getFeatureInfo = (url, layers) => {
    return dispatch => {
        dispatch(getFeatureInfoStarted());
        axiosRoot.all(layers.map(layer => axiosRoot.get(`${layer.layerUrl}${url}&layers=${layer.layerName}&query_layers=${layer.layerName}&viewparams=${layer.layerViewparams}`)))
            .then(axiosRoot.spread((...res) => {
                // all requests are now complete
                dispatch(getFeatureInfoSuccess(layers, res));
            }));
    };
};

export const getFeatureInfoStarted = () => {
    return {
        type: actionTypes.GET_FEATURE_INFO_STARTED
    };
};

export const getFeatureInfoSuccess = (layers, layersData) => {
    return {
        type: actionTypes.GET_FEATURE_INFO_SUCCESS,
        layers: layers,
        layersData: layersData
    };
};

export const getFeature = (mapLayers, latlng) => {
    return dispatch => {
        dispatch(getFeatureStart());
        axios.post( 'getFeature.php', {mapLayers:mapLayers, latlng:latlng} )
            .then(response => {
                console.log(response.data)
                dispatch(getFeatureSuccess(response.data));           
            })
            .catch( error => {
            });
    };
};

export const getFeatureStart = () => {
    return {
        type: actionTypes.GET_FEATURE_START
    };
};

export const getFeatureSuccess = (layersData) => {
    return {
        type: actionTypes.GET_FEATURE_SUCCESS,
        layersData: layersData
    };
};

export const changeFeaturePanel = (action) => {
    return {
        type: actionTypes.CHANGE_FEATURE_PANEL,
        action:action
    };
};

export const closePopup = () => {
    return {
        type: actionTypes.CLOSE_POPUP
    };
};